module.exports = __webpack_public_path__ + "img/gear-icon.02abb09.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/gear-icon.svg
// module id = s4r6
// module chunks = 13